module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/hearts.png?67f20aef31faf990a1a4d04652af4d75";